import Poster from './Poster'

const ThanksForWatching = () => <Poster
  headline="Thanks for watching."
  copy="Replay available soon!"
/>

export default ThanksForWatching
